import isEmpty from 'lodash-es/isEmpty'

import {
  CHARACTER_WHITESPACE,
  EMPTY_LIST,
  EMPTY_OBJECT,
} from '../../../../../constants/common'
import { isApiSuccessStatus } from '../../../../../utils/api'
import {
  getMassActionExcludeIdParam,
  getMassActionIdParam,
} from '../../../../../utils/common'
import { getRentalPortalApplicantIdentityLabel } from '../../../../RentalPortalApplicant'
import {
  APPLICANT_ACTION_ARCHIVE,
  APPLICANT_ACTION_ARCHIVE_MASS,
  APPLICANT_MASS_ACTION_NAMES,
} from '../../RentalPortalApplicants.constants'
import { getIsApplicantArchivable } from '../../RentalPortalApplicants.utils'

import { APPLICANT_SINGLE_ACTION_BY_MASS_ACTION } from './useRentalPortalApplicantsMassActions.constants'

export function getApplicantsMassActionRequest({
  action,
  eligibleIds,
  excludeIds,
  filterValues,
  ids,
  selectAllPages,
}) {
  const isAllPages = selectAllPages && isEmpty(ids)

  return {
    action: APPLICANT_MASS_ACTION_NAMES[action],
    all: isAllPages,
    filters: {
      ...filterValues,
      exclude_id:
        getMassActionExcludeIdParam({
          excludeIds,
          selectAllPages: isAllPages,
        }) ?? EMPTY_LIST,
      id:
        getMassActionIdParam({
          ids,
          selectAllPages: isAllPages,
          selectedIds: eligibleIds,
        }) ?? EMPTY_LIST,
    },
    payload: EMPTY_OBJECT,
  }
}

export function getApplicantsMassActionItems({
  allItems,
  excludeIds,
  selectAllPages,
  selected,
}) {
  return selectAllPages
    ? allItems.filter(applicant => !excludeIds.includes(applicant.id))
    : selected
}

export function getApplicantsMassActionEligibleItems(items) {
  return items.filter(getIsApplicantArchivable)
}

export function getApplicantsMassActionFailures({ items, resultItems, t }) {
  const failedItems = resultItems.filter(
    resultItem => !isApiSuccessStatus(resultItem.status_code)
  )

  return {
    count: failedItems.length,
    names: failedItems
      .map(resultItem => {
        const applicant = items.find(item => item.id === resultItem.id)

        return applicant
          ? getRentalPortalApplicantIdentityLabel({ applicant, t })
          : null
      })
      .filter(Boolean),
  }
}

export function getApplicantsMassActionFailureText({ failures, t }) {
  return failures.names.length === failures.count
    ? t('RentalPortal.ApplicantMassActionFailedItemsKey', {
        names: failures.names.join(', '),
      })
    : t('RentalPortal.ApplicantMassActionFailedCountKey', {
        count: failures.count,
      })
}

export function getNotificationTitle({ action, count, t, totalCount }) {
  const titleAction =
    totalCount > 1
      ? action
      : (APPLICANT_SINGLE_ACTION_BY_MASS_ACTION[action] ?? action)

  const titles = {
    [APPLICANT_ACTION_ARCHIVE]: t('Notification.CommonTitleArchivedKey'),
    [APPLICANT_ACTION_ARCHIVE_MASS]: t(
      'Notification.CommonTitleMassArchivedKey',
      { count, totalCount }
    ),
  }

  return titles[titleAction] || null
}

export function getApplicantsMassActionDescription({
  eligibleItems,
  selectedCount,
  t,
}) {
  const lines = [
    eligibleItems.length === 1
      ? t('RentalPortal.ApplicantProfileArchiveConfirmationTextKey', {
          name: getRentalPortalApplicantIdentityLabel({
            applicant: eligibleItems[0],
            t,
          }),
        })
      : t('RentalPortal.ApplicantArchiveMassConfirmationTextKey', {
          count: eligibleItems.length,
        }),
  ]

  if (eligibleItems.length < selectedCount) {
    lines.push(
      t('RentalPortal.ApplicantArchiveMassMixedEligibilityKey', {
        eligible: eligibleItems.length,
        selected: selectedCount,
      })
    )
  }

  return lines.join(CHARACTER_WHITESPACE)
}
